import React, {useCallback, useState} from "react";
import "./index.scss";
import {connect} from "react-redux";
import InvoiceForm from "features/forms/invoice";
import {
    invoiceDataSelector,
    saveInvoicingDataErrorSelector,
    saveInvoicingDataLoading
} from "store/reducer/payments/invoice/selectors";
import {saveInvoiceDataStart, setInvoice} from "store/reducer/payments/invoice/reducer";
import Button from "features/components/button";
import {__} from "services/i18n";
import Text from "features/components/text";
import PaymentForm from "features/forms/payment";
import {
    addPaymentErrorSelector,
    addPaymentLoading,
    deletePaymentErrorSelector, deletePaymentLoadingSelector,
    paymentCardsSelector
} from "store/reducer/payments/cards/selectors";
import {addNewPaymentMethodStart, deletePaymentMethodStart} from "store/reducer/payments/cards/reducer";
import {withToastManager} from "react-toast-notifications";
import {LoadingLogoPortal} from "features/components/loading-logo";

/* istanbul ignore next */
const mapStateToProps = state => ({
    invoice: {
        data: invoiceDataSelector(state),
        loading: saveInvoicingDataLoading(state),
        error: saveInvoicingDataErrorSelector(state)
    },
    cards: paymentCardsSelector(state),
    card_add: {
        loading: addPaymentLoading(state),
        error: addPaymentErrorSelector(state)
    },
    card_delete_error: deletePaymentErrorSelector(state),
    card_delete_loading: deletePaymentLoadingSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    setInvoice,
    saveInvoiceDataStart,
    addNewPaymentMethodStart,
    deletePaymentMethodStart
};

export const SettingsPayment = (props) => {
    const {invoice, cards, card_add, card_delete_error, card_delete_loading} = props;
    const {setInvoice, saveInvoiceDataStart, addNewPaymentMethodStart, deletePaymentMethodStart} = props;

    React.useEffect(() => {
        if(!card_delete_error.inError) return;
        props.toastManager.add(__(card_delete_error.error), { appearance: 'error', id: 'delete_card_error_modal' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [card_delete_error]);

    const invoiceForm = useCallback(() => {
        return <div className="invoice">
            <InvoiceForm {...invoice.data} onChange={setInvoice} />
            {invoice.error.inError && <Text size={16} align={"center"} color={"danger"}>{__(invoice.error.error)}</Text>}
            <Button title={__("buttons.save-edited-data")} onClick={saveInvoiceDataStart} icon={"save"} type={"accent"} status={invoice.loading ? "loading" : null} />
        </div>;
    }, [invoice, saveInvoiceDataStart, setInvoice]);

    const deletePaymentMethod = useCallback((stripe_id) => {
        deletePaymentMethodStart({id: stripe_id});
    }, [deletePaymentMethodStart]);

    const [payment, setPayment] = useState({valid: false});

    const addPaymentMethod = useCallback(() => {
        addNewPaymentMethodStart({card: payment.card})
    }, [addNewPaymentMethodStart, payment]);
    
    const paymentForm = useCallback(() => {
        return <div className="payment">
            <PaymentForm savedCards={cards} onChange={setPayment} deleteEnabled={true} onDelete={deletePaymentMethod} />
            {card_add.error.inError && <Text size={16} color={"danger"}>{__(card_add.error.error)}</Text> }
            <Button title={__("buttons.add-card")} onClick={addPaymentMethod} type={"outlined"} disabled={!payment.valid} status={card_add.loading ? "loading" : null} />
        </div>
    }, [addPaymentMethod, card_add.error.error, card_add.error.inError, card_add.loading, cards, deletePaymentMethod, payment.valid]);
    
    return <div className="settings-payment">
        {paymentForm()}
        {invoiceForm()}
        {card_delete_loading && <LoadingLogoPortal />}
    </div>
};
export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(SettingsPayment));